import {inject, IReactComponent} from 'mobx-react';
import * as component from './component';

const mapStoresToProps = (stores: any) => ({
    translate: stores.loginStore.localizationService.translate.bind(stores.loginStore.localizationService)
});

const RightSide = inject(mapStoresToProps)(component.RightSide) as IReactComponent;

export {RightSide};
export default RightSide;
